import { DatiqCellLocationPosition } from './datiq-cell-location.enum';
import { IDatiqCellLocation } from './datiq-cell-location.interface';
import { emptyDatiqGeoSuggestion } from '@dat/datiq-core/models';

export const emptyDatiqCellLocation: IDatiqCellLocation = {
    geoInfo: { ...emptyDatiqGeoSuggestion },
    location: DatiqCellLocationPosition.Unknown,
};
